<template>
  <div class="app-container">
    <!-- Zgornja navigacijska vrstica -->
    <header class="top-navbar">
      <router-link :to="homeLink" class="navbar-brand">
        <img src="@/assets/logo.svg" alt="AVTOVIZIJA Logo" />
      </router-link>

      <!-- Povezave za večje zaslone -->
      <nav class="main-nav">
        <router-link v-if="showAdsBoard" to="/ads" class="nav-link"><font-awesome-icon icon="car" /> OGLASI</router-link>
        <router-link v-if="showDraftsBoard" to="/carshowroom-drafts" class="nav-link"><font-awesome-icon icon="images" /> DRAFTI</router-link>
        <router-link v-if="showClientsBoard" to="/admin" class="nav-link"><font-awesome-icon icon="users" /> KLIENTI</router-link>
        <router-link v-if="showAdminAdsBoard" to="/admin/oglasi" class="nav-link"><font-awesome-icon icon="car" /> OGLASI</router-link>
        <router-link v-if="showAdminBoard" to="/reports/zgodovina-obnov" class="nav-link"><font-awesome-icon icon="history" /> ZGODOVINA OBNOV</router-link>
        <router-link v-if="showAdminBoard" to="/novosti" class="nav-link"><font-awesome-icon icon="bullhorn" /> NOVOSTI</router-link>
        <router-link v-if="showAdminBoard" to="/konfiguracija" class="nav-link"><font-awesome-icon icon="cogs" /> KONFIGURACIJA</router-link>
        <div v-if="showAdminBoard" class="nav-link nav-link--has-submenu" @mouseenter="handleMouseOverDoberAvto" @mouseleave="handleMouseLeaveDoberAvto">
          <span><font-awesome-icon icon="flask" /> DOBERAVTO</span>
          <div
            v-if="isDoberAvtoMenuVisible"
            class="sub-menu"
            @mouseenter="handleMouseOverDoberAvto"
            @mouseleave="handleMouseLeaveDoberAvto"
          >
            <router-link to="/admin/doberavto-sandbox" class="nav-link sub-nav-link">DOBERAVTO TEST</router-link>
            <router-link to="/admin/doberavto-log" class="nav-link sub-nav-link">DOBERAVTO LOG</router-link>
          </div>
        </div>
        <div v-if="showAdminBoard" class="nav-link nav-link--has-submenu" @mouseenter="handleMouseOverReports" @mouseleave="handleMouseLeaveReports">
          <span><font-awesome-icon icon="file-alt"/> POROČILA</span>
          <div
            v-if="isReportsMenuVisible"
            class="sub-menu"
            @mouseenter="handleMouseOverReports"
            @mouseleave="handleMouseLeaveReports"
          >
            <router-link to="/reports/active-sessions" class="nav-link sub-nav-link">AKTIVNE SEJE</router-link>
            <router-link to="/reports/errors" class="nav-link sub-nav-link">NAPAKE</router-link>
            <router-link to="/reports/renewal-logs" class="nav-link sub-nav-link">RENEWAL LOGS</router-link>
            <router-link to="/reports/statistika" class="nav-link sub-nav-link">STATISTIKA</router-link>
            <router-link to="/reports/zaloga-partnerjev" class="nav-link sub-nav-link">ZALOGA PO PARTNERJIH</router-link>
            <router-link to="/reports/avtonet-obvestila" class="nav-link sub-nav-link">AVTO.NET OBVESTILA</router-link>
            <router-link to="/reports/duplicate-listings" class="nav-link sub-nav-link">PODVOJENI OGLASI</router-link>
            <router-link to="/reports/parametri-vozila" class="nav-link sub-nav-link">PARAMETRI VOZILA</router-link>
            <router-link to="/reports/pametno-iskanje" class="nav-link sub-nav-link">PAMETNO ISKANJE</router-link>
          </div>
        </div>
      </nav>

      <div class="user-actions">
        <a v-if="isImpersonating" class="nav-link nav-link--admin-return" @click.prevent="returnToAdmin">
          <font-awesome-icon icon="arrow-left"/> NAZAJ V ADMIN
        </a>
        <router-link v-if="isLoggedIn" to="/profile" class="nav-link">
          <font-awesome-icon icon="user"/> PROFIL
        </router-link>
        <a v-if="isLoggedIn" class="nav-link" @click.prevent="logOut">
          <font-awesome-icon icon="sign-out-alt"/> ODJAVA
        </a>
        <router-link v-if="!isLoggedIn" to="/register" class="nav-link">
          <font-awesome-icon icon="user-plus"/> REGISTRACIJA
        </router-link>
        <router-link v-if="!isLoggedIn" to="/login" class="nav-link">
          <font-awesome-icon icon="sign-in-alt"/> PRIJAVA
        </router-link>
      </div>

      <button @click="toggleMobileMenu" class="mobile-menu-button">
        <font-awesome-icon icon="bars" />
      </button>
    </header>

    <!-- Mobilni meni (prej navbar-vertical) -->
    <nav class="navbar-vertical" :class="{ 'is-active': isMobileMenuOpen }">
      <router-link v-if="showAdsBoard" to="/ads" class="nav-link" @click="closeMobileMenu"><font-awesome-icon icon="car" /> OGLASI</router-link>
      <router-link v-if="showDraftsBoard" to="/carshowroom-drafts" class="nav-link" @click="closeMobileMenu"><font-awesome-icon icon="images" /> DRAFTI</router-link>
      <router-link v-if="showClientsBoard" to="/admin" class="nav-link" @click="closeMobileMenu"><font-awesome-icon icon="users" /> KLIENTI</router-link>
      <router-link v-if="showAdminAdsBoard" to="/admin/oglasi" class="nav-link" @click="closeMobileMenu"><font-awesome-icon icon="car" /> OGLASI</router-link>
      <router-link v-if="showAdminBoard" to="/reports/zgodovina-obnov" class="nav-link" @click="closeMobileMenu"><font-awesome-icon icon="history" /> ZGODOVINA OBNOV</router-link>
      <router-link v-if="showAdminBoard" to="/novosti" class="nav-link" @click="closeMobileMenu"><font-awesome-icon icon="bullhorn" /> NOVOSTI</router-link>
      <router-link v-if="showAdminBoard" to="/konfiguracija" class="nav-link" @click="closeMobileMenu"><font-awesome-icon icon="cogs" /> KONFIGURACIJA</router-link>
      <div v-if="showAdminBoard" class="nav-link" @click="handleClickDoberAvto">
        <span><font-awesome-icon icon="flask" /> DOBERAVTO</span>
      </div>
      <div v-if="isDoberAvtoMenuVisible && isMobile" class="sub-menu-mobile">
        <router-link to="/admin/doberavto-sandbox" class="nav-link sub-nav-link" @click="closeMobileMenu">DOBERAVTO TEST</router-link>
        <router-link to="/admin/doberavto-log" class="nav-link sub-nav-link" @click="closeMobileMenu">DOBERAVTO LOG</router-link>
      </div>
      <div v-if="showAdminBoard" class="nav-link" @click="handleClickReports">
        <span><font-awesome-icon icon="file-alt"/> POROČILA</span>
      </div>
      <div v-if="isReportsMenuVisible && isMobile" class="sub-menu-mobile">
        <router-link to="/reports/active-sessions" class="nav-link sub-nav-link" @click="closeMobileMenu">AKTIVNE SEJE</router-link>
        <router-link to="/reports/errors" class="nav-link sub-nav-link" @click="closeMobileMenu">NAPAKE</router-link>
        <router-link to="/reports/renewal-logs" class="nav-link sub-nav-link" @click="closeMobileMenu">RENEWAL LOGS</router-link>
        <router-link to="/reports/statistika" class="nav-link sub-nav-link" @click="closeMobileMenu">STATISTIKA</router-link>
        <router-link to="/reports/zaloga-partnerjev" class="nav-link sub-nav-link" @click="closeMobileMenu">ZALOGA PO PARTNERJIH</router-link>
        <router-link to="/reports/avtonet-obvestila" class="nav-link sub-nav-link" @click="closeMobileMenu">AVTO.NET OBVESTILA</router-link>
        <router-link v-if="showAdminBoard" to="/reports/duplicate-listings" class="nav-link sub-nav-link" @click="closeMobileMenu">PODVOJENI OGLASI</router-link>
        <router-link to="/reports/parametri-vozila" class="nav-link sub-nav-link" @click="closeMobileMenu">PARAMETRI VOZILA</router-link>
        <router-link to="/reports/pametno-iskanje" class="nav-link sub-nav-link" @click="closeMobileMenu">PAMETNO ISKANJE</router-link>
      </div>

      <div style="margin-top: auto; border-top: 1px solid var(--color-border); padding-top: 10px;">
        <a v-if="isImpersonating" class="nav-link nav-link--admin-return" @click.prevent="returnToAdminAndCloseMenu">
          <font-awesome-icon icon="arrow-left"/> NAZAJ V ADMIN
        </a>
        <router-link v-if="isLoggedIn" to="/profile" class="nav-link" @click="closeMobileMenu">
          <font-awesome-icon icon="user"/> PROFIL
        </router-link>
        <a v-if="isLoggedIn" class="nav-link" @click.prevent="logOutAndCloseMenu">
          <font-awesome-icon icon="sign-out-alt"/> ODJAVA
        </a>
      </div>
    </nav>


    <!-- Glavna vsebina -->
    <main class="main">
      <div class="main-content">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowLeft, faBars, faBullhorn, faCar, faUsers, faCogs, faUserPlus, faSignInAlt, faSignOutAlt, faUser, faFileAlt, faHistory, faImages, faFlask } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(faArrowLeft, faBars, faBullhorn, faCar, faUsers, faCogs, faUserPlus, faSignInAlt, faSignOutAlt, faUser, faFileAlt, faHistory, faImages, faFlask);

export default {
  name: 'DefaultLayout',
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      isReportsMenuVisible: false,
      isDoberAvtoMenuVisible: false,
      isMobileMenuOpen: false,
      isMobile: false,
      reportsHideTimer: null,
      doberAvtoHideTimer: null
    };
  },
  computed: {
    homeLink() {
      if (this.showClientsBoard) {
        return '/admin';
      }
      if (this.showAdsBoard) {
        return '/ads';
      }
      return '/profile'; // Fallback for other logged-in users like moderator
    },
    isLoggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    isImpersonating() {
      return Boolean(this.$store.state.auth.adminUserBeforeImpersonation);
    },
    showAdminBoard() {
      return this.currentUser?.roles?.includes('ROLE_ADMIN') || false;
    },
    showClientsBoard() {
      return this.showAdminBoard || this.currentUser?.roles?.includes('ROLE_PARTNER') || false;
    },
    showAdminAdsBoard() {
      return this.showAdminBoard;
    },
    showModeratorBoard() {
      return this.currentUser?.roles?.includes('ROLE_MODERATOR') || false;
    },
    showAdsBoard() {
      return (this.currentUser?.roles?.includes('ROLE_USER') || false) && !this.showClientsBoard;
    },
    showDraftsBoard() {
      return this.currentUser?.roles?.some(role => ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PARTNER'].includes(role)) || false;
    },
    pageTitle() {
      return this.$route.meta.title || 'AVTOVIZIJA';
    }
  },
  methods: {
    toggleMobileMenu() {
      if (this.isMobile) {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
      }
    },
    closeMobileMenu() {
      if (this.isMobile) {
        this.isMobileMenuOpen = false;
        this.isReportsMenuVisible = false;
        this.isDoberAvtoMenuVisible = false;
      }
    },
    handleMouseOverReports() {
      if (!this.isMobile) {
        if (this.reportsHideTimer) {
          clearTimeout(this.reportsHideTimer);
          this.reportsHideTimer = null;
        }
        this.isReportsMenuVisible = true;
      }
    },
    handleMouseLeaveReports() {
      if (!this.isMobile) {
        if (this.reportsHideTimer) {
          clearTimeout(this.reportsHideTimer);
        }
        this.reportsHideTimer = setTimeout(() => {
          this.isReportsMenuVisible = false;
          this.reportsHideTimer = null;
        }, 180);
      }
    },
    handleClickReports(event) {
      if(this.isMobile) {
        this.isReportsMenuVisible = !this.isReportsMenuVisible;
      }
    },
    handleMouseOverDoberAvto() {
      if (!this.isMobile) {
        if (this.doberAvtoHideTimer) {
          clearTimeout(this.doberAvtoHideTimer);
          this.doberAvtoHideTimer = null;
        }
        this.isDoberAvtoMenuVisible = true;
      }
    },
    handleMouseLeaveDoberAvto() {
      if (!this.isMobile) {
        if (this.doberAvtoHideTimer) clearTimeout(this.doberAvtoHideTimer);
        this.doberAvtoHideTimer = setTimeout(() => {
          this.isDoberAvtoMenuVisible = false;
          this.doberAvtoHideTimer = null;
        }, 180);
      }
    },
    handleClickDoberAvto() {
      if (this.isMobile) {
        this.isDoberAvtoMenuVisible = !this.isDoberAvtoMenuVisible;
      }
    },
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    logOutAndCloseMenu() {
      this.logOut();
      this.closeMobileMenu();
    },
    returnToAdmin() {
      this.$store.dispatch('auth/returnToAdmin');
    },
    returnToAdminAndCloseMenu() {
      this.returnToAdmin();
      this.closeMobileMenu();
    },
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) {
        this.isMobileMenuOpen = false;
      }
    }
  },
  mounted() {
    this.checkIfMobile();
    window.addEventListener('resize', this.checkIfMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkIfMobile);
    if (this.reportsHideTimer) {
      clearTimeout(this.reportsHideTimer);
      this.reportsHideTimer = null;
    }
    if (this.doberAvtoHideTimer) {
      clearTimeout(this.doberAvtoHideTimer);
      this.doberAvtoHideTimer = null;
    }
  }
};
</script>

<style scoped>
.sub-menu {
  position: absolute;
  top: calc(100% - 2px);
  background: var(--header-bg);
  border: 1px solid var(--color-border);
  border-top: none;
  border-radius: 0 0 8px 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0,0,0,0.4);
  z-index: 1000;
}
.sub-menu-mobile {
  padding-left: 20px;
}
.nav-link > span {
  cursor: pointer;
}
.nav-link--has-submenu {
  position: relative;
}
.nav-link:hover .sub-menu {
  display: flex;
}
.sub-nav-link {
  font-size: 0.9rem;
}
@media (max-width: 768px) {
  .main-nav {
    display: none;
  }
  .user-actions {
    display: none;
  }
}
</style>
